import { getIsApiPending } from '../../../selectors/naMotorInsurance/quote';
import {
    apiTransitionMotorInsuranceQuoteForm,
    calculateMotorInsurancePremiumSuccess,
} from '../../../actions/naMotorInsurance/quote';
import { getAccessToken } from '../../../selectors/naMotorInsurance/payments';
import axios from 'axios';

export const thirdPartyPremiumCalculationService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionMotorInsuranceQuoteForm.pending());
            try {
                const resp = await calculate(store.getState());
                store.dispatch(calculateMotorInsurancePremiumSuccess(resp.data));
                store.dispatch(apiTransitionMotorInsuranceQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionMotorInsuranceQuoteForm.failure());
            }
        }
    })();
    return next(action);
};

const premiumCalculationPayload = () => {
    const premiumCalculationPayload = {
        months: '12',
    };

    // Change payload here
    return {
        ...premiumCalculationPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/na-motor-insurance/third-party-premium-calculation/namibia';
        return await axios.post(url, premiumCalculationPayload(), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData?.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
